import {BetLineNumber} from "@nolimitcity/slot-game/bin/core/betline/BetLineNumber";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {ITextBetLineNumberConfig} from "@nolimitcity/slot-game/bin/game/betline/number/TextBetLineNumber";
import {TweenLite} from "gsap";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";

export function isNumber(value:any):value is number {
    return typeof value === "number" && value === value;
}

export interface ICCTWoTextBetLineNumberConfig extends ITextBetLineNumberConfig {
    readonly freeSTextStyleNormal:TextStyleOptions;
    readonly freeSTextStyleWin:TextStyleOptions;
}

export class CCTwoTextBetLineNumber extends BetLineNumber {

    private readonly _config:ICCTWoTextBetLineNumberConfig;
    private readonly _horizontalPadding:[number, number];
    private readonly _verticalPadding:[number, number];

    private _normalText:PIXI.Text;
    private _normalTextAlphaTween:TweenLite;
    private _normalTextScaleTween:TweenLite;
    private _winText:PIXI.Text;
    private _winTextAlphaTween:TweenLite;
    private _winTextScaleTween:TweenLite;

    constructor(index:number, config:ICCTWoTextBetLineNumberConfig) {
        super(index, config);
        this._config = config;
        if(isNumber(this._config.horizontalPadding)) {
            this._horizontalPadding = [this._config.horizontalPadding - 1, this._config.horizontalPadding + 20];
        } else {
            this._horizontalPadding = this._config.horizontalPadding;
        }

        if(isNumber(this._config.verticalPadding)) {
            this._verticalPadding = [this._config.verticalPadding, this._config.verticalPadding];
        } else {
            this._verticalPadding = this._config.verticalPadding;
        }
        this.on('mouseover', this.onshowMouseOver);
    }

    // Hardcoded default even number betLines. positionIndex starts from 0.
    public setPosition(betLinesNum:number, positionIndex:number):number[] {
        const stageWidth:number = GameConfig.instance.GAME_WIDTH;
        const stageHeight:number = GameConfig.instance.GAME_HEIGHT;
        const numLineInOneSide:number = betLinesNum / 2;
        const numberLeftPositionX:number = this._horizontalPadding[0];
        const numberRightPositionX:number = stageWidth - this._horizontalPadding[1];
        const numberVerticalSpace:number = (stageHeight - this._verticalPadding[0] - this._verticalPadding[1]) / (numLineInOneSide - 1);

        const side:number = Math.floor(positionIndex / numLineInOneSide);
        const x:number = side === 0 ? numberLeftPositionX : numberRightPositionX;
        const y:number = Math.round(positionIndex % numLineInOneSide * numberVerticalSpace + this._verticalPadding[0]);
        const betLineNum = CreepyCarnivalTwoGameConfig.instance.BETLINES.indexOf(this.index);
        if(betLineNum % 2 !== 0) {
            this.x = side === 0 ? x + 2 : x + 23;
            this.children[1].x = side === 0 ? 3 : -3;
            this.children[2].x = side === 0 ? 3 : -3;

        } else {
            this.x = side === 0 ? x - 31 : x + 51;
            this.children[1].x = side === 0 ? -5 : +5;
            this.children[2].x = side === 0 ? -5 : +5;
            this.children[1].y = -5;
            this.children[2].y = -5;

        }
        // this.x = x;
        this.y = y - 13;
        //to position numbers on betline tickets

        return [x, y, side];
    }

    protected draw(config:ICCTWoTextBetLineNumberConfig):void {
        const betLineNum = CreepyCarnivalTwoGameConfig.instance.BETLINES.indexOf(this.index);
        if(betLineNum % 2 !== 0) {
            this._normalText = new PIXI.Text(this.index.toString(), config.textStyleNormal);
            this.addChild(this.applyBackground(config.width, config.height, "assets/ticket_orange", 1));
        } else {
            this._normalText = new PIXI.Text(this.index.toString(), config.freeSTextStyleNormal);
            this.addChild(this.applyBackground(config.width, config.height, "assets/ticket_red", 1.2));
        }

        //this._normalText = new PIXI.Text(this.index.toString(), config.textStyleNormal);
        this._normalText.anchor.set(0.5, 0.55);
        this.addChild(this._normalText);

        this._winText = new PIXI.Text(this.index.toString(), config.freeSTextStyleWin);
        this._winText.anchor.set(0.5, 0.55);
        this._winText.alpha = 0;
        this.addChild(this._winText);

        StageManager.getLayer(config.layer).addChild(this);
    }

    protected showMouseOver():void {

    }

    protected showMouseOut():void {
        this.killAllTweens();
        if(this.alpha) {
            this._normalTextAlphaTween = TweenLite.to(this._normalText, 0.1, {alpha : 1});
            this._winTextAlphaTween = TweenLite.to(this._winText, 0.1, {alpha : 0});
        }

    }

    protected showWin():void {
        this.killAllTweens();
        this._normalTextAlphaTween = TweenLite.to(this._normalText, 0.1, {alpha : 0});
        this._winTextAlphaTween = TweenLite.to(this._winText, 0.1, {alpha : 1});
        this._normalTextScaleTween = TweenLite.to(this._normalText.scale, 0.17, {
            x : this._config.textWinScale,
            y : this._config.textWinScale
        });
        this._winTextScaleTween = TweenLite.to(this._winText.scale, 0.17, {
            x : this._config.textWinScale,
            y : this._config.textWinScale
        });
    }

    protected showNormal():void {
        this.killAllTweens();
        this._normalTextAlphaTween = TweenLite.to(this._normalText, 0.33, {alpha : 1});
        this._winTextAlphaTween = TweenLite.to(this._winText, 0.33, {alpha : 0});
        this._normalTextScaleTween = TweenLite.to(this._normalText.scale, 0.33, {x : 1, y : 1});
        this._winTextScaleTween = TweenLite.to(this._winText.scale, 0.33, {x : 1, y : 1});
    }

    private killAllTweens():void {
        if(this._normalTextAlphaTween && this._normalTextAlphaTween.isActive()) {
            this._normalTextAlphaTween.pause();
            this._normalTextAlphaTween.kill();
        }

        if(this._normalTextScaleTween && this._normalTextScaleTween.isActive()) {
            this._normalTextScaleTween.pause();
            this._normalTextScaleTween.kill();
        }

        if(this._winTextAlphaTween && this._winTextAlphaTween.isActive()) {
            this._winTextAlphaTween.pause();
            this._winTextAlphaTween.kill();
        }

        if(this._winTextScaleTween && this._winTextScaleTween.isActive()) {
            this._winTextScaleTween.pause();
            this._winTextScaleTween.kill();
        }
    }

    private onshowMouseOver():void {
        this.killAllTweens();
        if(this.alpha) {
            this._normalTextAlphaTween = TweenLite.to(this._normalText, 0.1, {alpha : 0});
            this._winTextAlphaTween = TweenLite.to(this._winText, 0.1, {alpha : 1});
        } else {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_STATIC_BET_LINE, this.index));
        }

    }

    private applyBackground(width:number, height:number, resource:string, scaleX:number):PIXI.DisplayObject {
        const background:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(resource)[0]);
        background.anchor.set(0.5, 0.5);
        background.scale.set(scaleX, 1);
        // background.beginFill(0x000000, 0);
        // background.drawRect(0, 0, width, height);
        // background.endFill();
        return background;
    }
}